<template>
  <b-row class="g-2">
    <b-col v-for="item in landingBars" :key="`bars-${item.id}`">
      <b-card no-body class="h-100">
        <b-card-body class="text-info-box__body">
          <h3 class="text-info-box__title" v-html="item.label" />
          <div class="text-info-box__text" :class="{'list-style-unset': sid === 'abaooe'}" v-html="item.info_text"></div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class TextInformationBox extends Vue {
  get landingBars() {
    return AppModule.settingPortal.landing_bars;
  }

  get sid() {
    return AppModule.sid;
  }
}
</script>
<style lang="scss" scoped>
  .list-style-unset ::v-deep li {
    list-style: unset;
  }

  .text-info-box__body {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1.25rem;
  }

  .text-info-box__title {
    margin: 0 0 .75rem;
    color: #0054A6;
    font-family: Roboto, Arial, sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
  }

  .text-info-box__text {
    color: #333333;
    font-family: Roboto, Arial, sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.6;

    ::v-deep p {
      margin: 0;

      & + p {
        margin-top: .75rem;
      }
    }
  }
</style>
